export const defaultDocumentsAlerts = {
  DOCUMENT_FILE_ID_NOT_FOUND_TITLE: 'Invalid document id',
  DOCUMENT_FILE_ID_NOT_FOUND_DESCRIPTION: 'Document file id not found',
  DOCUMENT_ID_NOT_FOUND_TITLE: 'Invalid document id',
  DOCUMENT_ID_NOT_FOUND_DESCRIPTION: 'Please check your document id.',
  DOCUMENT_TYPE_NOT_FOUND_TITLE: 'Invalid document type',
  DOCUMENT_TYPE_NOT_FOUND_DESCRIPTION: 'Please check your document type.',
  DOCUMENT_UPLOAD_SUCCESS_TITLE: 'Upload successful',
  DOCUMENT_UPLOAD_SUCCESS_DESCRIPTION: 'Documents uploaded successfully',
  DOCUMENT_UPLOAD_FAILED_TITLE: 'Upload failed',
  DOCUMENT_UPLOAD_FAILED_DESCRIPTION: 'Failed to upload document. Please try again.',
  DOCUMENT_FILE_SIZE_EXCEEDED_TITLE: 'File is too large',
  DOCUMENT_FILE_SIZE_EXCEEDED_DESCRIPTION:
    'The maximum file size is 20 MB. Please select a smaller document and try again.',
  DOCUMENT_GENERATION_FAILED_TITLE: 'Generation failed',
  DOCUMENT_GENERATION_FAILED_DESCRIPTION: 'Failed to generate document. Please try again.',
  HOLDING_STATEMENT_NOT_IMPLEMENTED_TITLE: 'Holding statement not implemented',
  HOLDING_STATEMENT_NOT_IMPLEMENTED_DESCRIPTION: 'Holding statement is not implemented yet.',
};
